import React from 'react';
import { useGetGlobalAttributes } from '../../globalProps';

export const TestComponent = (props) => {
  const globalAttributes = useGetGlobalAttributes(props);

  return <div {...globalAttributes}>Some random div</div>;
};
